import { AxiosInstance } from "axios";
import { toQueryString } from "@/utils/queryParams";
import {
  DemergerDTO,
  LiquidationDTO,
  MergerDTO,
  OwnersPerDateDTO,
  RegisterCompanyStatusChangeRequest,
} from "@/types/Transactions";

export class TransactionApiClient {
  private http: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.http = axiosInstance;
  }

  async fetchInitialTransactionState(
    orgNo: string,
    date: string,
  ): Promise<InitialTransactionState> {
    const res = await this.http.get(
      `/transaction/${orgNo}/initial-state${toQueryString({ date })}`,
    );
    return res.data;
  }

  async registerLiquidation(transaction: LiquidationDTO): Promise<number> {
    const res = await this.http.post(`/transaction/liquidation`, transaction);
    return await res.data;
  }

  async registerMerger(
    transaction: MergerDTO,
    registerForTransferringCompany?: boolean,
  ): Promise<number> {
    const res = await this.http.post(
      `/transaction/merger${toQueryString({ registerForTransferringCompany })}`,
      transaction,
    );
    return await res.data;
  }

  async registerDemerger(transaction: DemergerDTO): Promise<number> {
    const res = await this.http.post(`/transaction/demerger`, transaction);
    return await res.data;
  }

  async registerOwnersPerDate(transaction: OwnersPerDateDTO): Promise<number> {
    const res = await this.http.post(`/transaction/ownersperdate`, transaction);
    return await res.data;
  }

  async registerCompanyStatusChange(request: RegisterCompanyStatusChangeRequest): Promise<number> {
    const res = await this.http.post(`/transaction/companystatuschange`, request);
    return await res.data;
  }

  async updateTransaction(transactionId: string | number, payload: unknown): Promise<number> {
    const res = await this.http.post(`/transaction/${transactionId}`, payload);
    return await res.data;
  }

  async importTransactions(
    orgNo: string,
    file: File,
    language: string,
  ): Promise<ImportTransactionsResult> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("language", language);
    const res = await this.http.post(`/transactionlog/import/${orgNo}`, formData);
    return res.data;
  }
}

export type ImportTransactionsResult = {
  succeeded: number;
  failed: Array<{ sheet: string; row: number; reason: string }>;
};

export type InitialTransactionState = {
  shareNominalValue: number;
  totalNumberOfShares: number;
};
